export default "__VITE_ASSET__CAfxHI2N__"